"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingContainer = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Container_1 = require("../../UI/Container");
exports.Container = (0, styled_components_1.default)(Container_1.Container) `
  flex: 1;
  margin-bottom: ${props => props.theme.spacing.xl1}px;
  display: flex;
  flex-direction: column;
  @media (max-width: ${props => props.theme.breakpoints.xxl}px) {
    max-width: none;
  }
`;
exports.LoadingContainer = styled_components_1.default.div `
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
`;
exports.default = {
    Container: exports.Container
};
